module.exports = __webpack_public_path__ + "static/media/product_list_tile_icon.55964f8a.svg";